import React from "react"
import { PageNoFound } from "../../components/404/PageNoFound"

export const Page404 = () => (
  <div>
		<PageNoFound></PageNoFound>
  </div>
)